import React from 'react';

interface SkeletonProps {
  className?: string;
}

export function Skeleton({ className = '' }: SkeletonProps) {
  return (
    <div className={`animate-pulse bg-bg-tertiary rounded ${className}`} />
  );
}

export function CoinItemSkeleton() {
  return (
    <div className="bg-gradient-to-br from-bg-secondary to-bg-tertiary rounded-3xl p-6 flex items-center justify-between gap-6 border-2 border-primary/10">
      <div className="flex items-center gap-5 flex-1">
        <Skeleton className="w-16 h-16 rounded-2xl" />
        <div className="flex-1">
          <Skeleton className="h-6 w-32 mb-2" />
          <Skeleton className="h-4 w-16" />
        </div>
      </div>
      <div className="text-right">
        <Skeleton className="h-7 w-24 mb-2 ml-auto" />
        <Skeleton className="h-8 w-20 ml-auto rounded-full" />
      </div>
    </div>
  );
}

export function CoinListSkeleton({ count = 10 }: { count?: number }) {
  return (
    <div className="flex flex-col gap-4">
      {Array.from({ length: count }).map((_, i) => (
        <CoinItemSkeleton key={i} />
      ))}
    </div>
  );
}

export function MarketStatsSkeleton() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
      {Array.from({ length: 3 }).map((_, i) => (
        <div key={i} className="bg-gradient-to-br from-bg-secondary to-bg-tertiary p-7 rounded-3xl border-2 border-primary/10">
          <Skeleton className="w-12 h-12 rounded-full mx-auto mb-3" />
          <Skeleton className="h-4 w-32 mx-auto mb-3" />
          <Skeleton className="h-8 w-24 mx-auto" />
        </div>
      ))}
    </div>
  );
}

export function CoinDetailSkeleton() {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-5">
          <Skeleton className="w-20 h-20 rounded-2xl" />
          <div>
            <Skeleton className="h-8 w-40 mb-2" />
            <Skeleton className="h-5 w-24" />
          </div>
        </div>
        <Skeleton className="h-10 w-32 rounded-full" />
      </div>
      <Skeleton className="h-64 w-full rounded-2xl" />
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="p-4 bg-bg rounded-2xl">
            <Skeleton className="h-4 w-20 mb-2" />
            <Skeleton className="h-6 w-24" />
          </div>
        ))}
      </div>
    </div>
  );
}

